import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { InfoButton } from 'components/buttons'
import NewCategoryModal from '../organize/new-category-modal'
import { registryPath } from 'lib/urls'

export default class OrganizeHeader extends PureComponent {
  state = {
    showNewCategoryModal: false,
  }

  showNewCategoryModal = () => this.setState({ showNewCategoryModal: true })
  hideNewCategoryModal = () => this.setState({ showNewCategoryModal: false })

  render() {
    const { registryUrlSlug } = this.props

    return (
      <React.Fragment>
        <div className={classNames('mtl mtxxl-md mbl flex center')}>
          <div className="hidden-xs h6 pan man">
            <strong>Drag to reorder items</strong> within a category.
            <br /> <strong>Use the dropdown menu to move items</strong> to a new
            category.
          </div>
          <div className="flex row justify-end center flex-grow">
            <InfoButton
              className="mrm"
              size="small"
              empty
              pill
              onClick={this.showNewCategoryModal}
            >
              + New Category
            </InfoButton>
            <Link to={registryPath(registryUrlSlug)}>
              <InfoButton size="small" empty pill>
                Done Organizing
              </InfoButton>
            </Link>
          </div>
        </div>
        <NewCategoryModal
          show={this.state.showNewCategoryModal}
          onHide={this.hideNewCategoryModal}
        />
      </React.Fragment>
    )
  }
}
